<template>
  <div class="separator">
  </div>
</template>

<script>
export default {
  name: 'separatorview',
  data() {
    return {

    };
  },
};
</script>

<style scoped lang="less">
  .separator{
  height: 30px;
  background: #f5f5f5;
}
</style>
